import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'semantic-ui-react';

const AdminListTable = ({ columnsName, apiData, recordsPerPage, next }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Table className="text-sm tableData text-left rtl:text-right ">
        <Table.Header className="text-xs text-white bg-customgreen uppercase ">
          <Table.Row>
            {columnsName.map((item, index) => {
              return <Table.HeaderCell className="text-white">{t(item)}</Table.HeaderCell>;
            })}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {apiData?.map((data, index) => {
            const sno = (next - 1) * recordsPerPage + index + 1;
            return (
              <Table.Row key={index}>
                <Table.Cell>{sno}</Table.Cell>
                <Table.Cell>{data.userName}</Table.Cell>
                <Table.Cell>{data.countryName}</Table.Cell>
                <Table.Cell>{data.date}</Table.Cell>
                <Table.Cell>{data.timeNow}</Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </div>
  );
};

export default AdminListTable;
